import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  connect() {
    this.inputTarget.addEventListener("keydown", this.handleKey.bind(this))
  }

  disconnect() {
    this.inputTarget.removeEventListener("keydown", this.handleKey.bind(this))
  }

  handleKey(e) {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault()
      this.element.requestSubmit()
    }
  }
}
